module.exports = __webpack_public_path__ + "assets/img/7cb25da6157c4a2f8446b385bd625bc6.svg";